<template>
  <v-row>
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
      :width="dialogWidth + 'px'"
      :height="dialogHeight + 'px'"
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <div style="overflow: auto; max-height: 90vh; max-width: 90vw">
          <organization-pdf
            ref="organizationPdf"
            v-show="dialog"
            :selected="selected"
            :TypeNivel="TypeNivel"
            :PstIsPermanent="PstIsPermanent"
            :TypeDiagram="TypeDiagram"
            @closedialogPdf="CloseDialog()"
          ></organization-pdf>
        </div>
      </v-card>
    </v-dialog>

    <v-col lg="12">
      <s-toolbar label="Organigrama"></s-toolbar>
      <v-card elevation="0">
        <v-col>
          <v-row justify="center">
            <v-col class="s-col-form" sm="2">
              <v-label>Tipo de Cargo</v-label>
              <v-select
                v-model="PstIsPermanent"
                :items="itemsTypePosition"
                item-text="text"
                item-value="value"
              ></v-select>
            </v-col>
            <!-- <v-col class="s-col-form" sm="2">
              <v-label>Tipo de Area</v-label>
              <v-select v-model="TypeArea" :items="itemsTypeArea" item-text="text" item-value="value"></v-select>
            </v-col> -->
            <v-col class="s-col-form" sm="4">
              <s-select-area
                style="margin-top: 20px"
                label="Área"
                v-model="area.AreID"
                :text="area.AreName"
              ></s-select-area>
            </v-col>
            <v-col class="s-col-form " sm="2">
              <v-checkbox
                v-model="TypeDiagram"
                label="Diagrama por Área"
                style="margin-top: 30px"
              ></v-checkbox>
            </v-col>
            <v-col class="s-col-form" sm="2">
              <v-btn
                @click="openMap()"
                color="primary"
                style="margin-top: 30px"
              >
                <v-icon>mdi mdi-eye</v-icon>
                Visualizar
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <div id="PartitionChart" ref="chart"></div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
html2canvas;
import html2canvas from "html2canvas";
import ServiceOrganization from "./../../services/HumanResource/OrganizationLevelService";
import Org from "./../../components/Org/Org.vue";
import OrganizationPdf from "./OrganizationPdf.vue";
import SSelectArea from "../../components/Utils/SSelectArea.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as d3 from "d3";

export default {
  name: "Organization",
  components: {
    Org,
    OrganizationPdf,
    SSelectArea,
  },
  data() {
    return {
      isDataLoaded: false,
      PstIsPermanent: null,
      //TypeArea: 1,
      selectedEdit: null,
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      open: [],
      dialogWidth: 800,
      dialogHeight: 600,
      chartData: null,
      area: {
        AreID: null,
        AreName: null,
      },
      refreshTable: false,
      TypeDiagram: false,
      edit: false,
      remove: false,
      orgv: false,
      active: [],
      selectedNoLevel: null,
      org: {
        PstID: null,
        PstParentID: null,
      },
      items: [],
      TypeNivel: 0,
      itemsTypePosition: [
        { text: "SOLO FIJOS", value: 1 },
        { text: "TODOS", value: null },
      ],
      // itemsTypeArea: [
      //   { text: "Departamento", value: 1 },
      //   { text: "Área", value: 3 },
      //   //{ text: "Sub-Área", value: 3 },
      // ],
    };
  },
  computed: {
    selected() {
      if (!this.active.length) {
        return undefined;
      } else this.selectedEdit = { ...this.active[0] };
      this.active = [this.active[this.active.length - 1]];
      this.PstName = this.active[0]?.name || "";
      this.AreName = this.active[0]?.AreName || "";
      this.level = this.active[0]?.TypeOrgLevel || 0;
      return this.active[0];
    },
  },
  watch: {
    "area.AreID": "load",
    PstIsPermanent: "load",
    //TypeArea: "load",
    TypeDiagram: "load",
    active() {
      this.edit = true;
      this.remove = true;
      this.orgv = true;
    },
  },
  methods: {
    rowsSelected(items) {
      if (items.length > 0) this.selectedNoLevel = items[0];
      else this.selectedNoLevel = null;
    },
    load() {
      this.active = [];
      this.items = [];

      let obj = {
        PstParentID: null,
        PstID: null,
        PstName: null,
        TypeOrgLevel: null,
        PstIsPermanent: this.PstIsPermanent,
        TypeArea: this.TypeArea,
        AreID: this.area.AreID,
        AreName: this.AreName,
      };
      ServiceOrganization.listLevel(obj).then((r) => {
        this.chartData = this.transformDataForChart(r.data[0]);
        this.active = [];
        this.active.push(this.chartData);
        this.drawChart();
      });
      this.$nextTick(() => {
        if (!this.TypeDiagram && this.$refs.drawLines) {
          this.$refs.drawLines.redraw && this.$refs.drawLines.redraw();
        }
      });
    },
    transformDataForChart(data, parent = {}) {
      return {
        name: data.PstName,
        value: data.PstID,
        level: data.TypeOrgLevel,
        parent: parent || null,
        AreID: data.AreID,
        AreName: data.AreName,
        OrgIsAsistent: data.OrgIsAsistent,
        showChildren: data.GenPositionChild.length > 0,
        children: data.GenPositionChild.map((child) =>
          this.transformDataForChart(child, {
            name: data.PstName,
            value: data.PstID,
            level: data.TypeOrgLevel,
            parent: parent || null,
            AreID: data.AreID,
            AreName: data.AreName,
            OrgIsAsistent: data.OrgIsAsistent,
            showChildren: data.GenPositionChild.length > 0,
          })
        ),
      };
    },
    async openMap() {
      if (!this.isDataLoaded) {
        const orgElement = document.getElementById("org");
        if (orgElement) {
          const { width, height } = orgElement.getBoundingClientRect();
          this.dialogWidth = width + 100;
          this.dialogHeight = height + 100;
        }

        // Cargar los datos del organigrama solo si no están cargados
        await this.$refs.organizationPdf?.$refs.orgDATA?.load?.();
        this.isDataLoaded = true;
      }

      this.dialog = true;

      // Forzar refresco de líneas después de mostrar el modal
      this.$nextTick(() => {
        if (!this.TypeDiagram) {
          // Espera a que el DOM esté listo y fuerza el refresco
          setTimeout(() => {
            const orgComp = this.$refs.organizationPdf?.$refs.orgDATA;
            if (orgComp && orgComp.$refs && orgComp.$refs.drawLines) {
              orgComp.$refs.drawLines.refreshLines();
            }
          }, 200);
        }
      });
    },
    CloseDialog() {
      this.dialog = false;

      // Recargar los datos solo si es necesario
      this.$nextTick(() => {
        this.isDataLoaded = false; // Permitir que los datos se recarguen si se vuelve a abrir el modal
      });
    },
    drawChart() {
      if (!this.chartData) return; // Asegúrate de que los datos estén disponibles
      d3.select(this.$refs.chart)
        .selectAll("*")
        .remove();

      const width = 600;
      const height = width * 0.8;
      const radius = width / 8;

      // Crear el color para los nodos
      const color = d3.scaleOrdinal(
        d3.quantize(d3.interpolateRainbow, this.chartData.children.length + 1)
      );

      // Crear la jerarquía de datos
      const hierarchy = d3
        .hierarchy(this.chartData)
        .sum((d) => d.value)
        .sort((a, b) => b.value - a.value);

      const root = d3.partition().size([2 * Math.PI, hierarchy.height + 1])(
        hierarchy
      );

      root.each((d) => (d.current = d));

      // Crear el generador de arcos
      const arc = d3
        .arc()
        .startAngle((d) => d.x0)
        .endAngle((d) => d.x1)
        .padAngle((d) => Math.min((d.x1 - d.x0) / 2, 0.005))
        .padRadius(radius * 1.5)
        .innerRadius((d) => d.y0 * radius)
        .outerRadius((d) => Math.max(d.y0 * radius, d.y1 * radius - 1));

      // Crear el contenedor SVG
      const svg = d3
        .select(this.$refs.chart)
        .append("svg")
        .attr("viewBox", [-width / 2, -height / 2, width, width])
        .style("font", "5px sans-serif");

      // Agregar texto central
      const centralText = svg
        .append("text")
        .attr("text-anchor", "middle")
        .attr("dy", "-0.5em")
        .style("font-size", "10px")
        .style("font-weight", "bold")
        .text(root.data.name); // Mostrar el nombre del nodo raíz inicialmente

      // Dibujar los arcos
      const path = svg
        .append("g")
        .selectAll("path")
        .data(root.descendants().slice(1))
        .join("path")
        .attr("fill", (d) => {
          while (d.depth > 1) d = d.parent;
          return color(d.data.name);
        })
        .attr("fill-opacity", (d) =>
          arcVisible(d.current) ? (d.children ? 0.6 : 0.4) : 0
        )
        .attr("pointer-events", (d) =>
          arcVisible(d.current) ? "auto" : "none"
        )
        .attr("d", (d) => arc(d.current));

      // Agregar interactividad (zoom al hacer clic)
      path
        .filter((d) => d.children)
        .style("cursor", "pointer")
        .on("click", clicked);

      // Agregar etiquetas
      const wrapText = (text, width) => {
        text.each(function() {
          const textElement = d3.select(this);
          const words = textElement
            .text()
            .split(/\s+/)
            .reverse();
          let line = [];
          let lineNumber = 0;
          const lineHeight = 1.2;
          const x = 0;
          const y = 0;
          let tspan = textElement
            .text(null)
            .append("tspan")
            .attr("x", x)
            .attr("dy", "0em");

          let word;
          while ((word = words.pop())) {
            line.push(word);
            tspan.text(line.join(" "));
            if (tspan.node().getComputedTextLength() > width) {
              line.pop();
              tspan.text(line.join(" "));
              line = [word];
              tspan = textElement
                .append("tspan")
                .attr("x", x)
                .attr("dy", `${lineHeight}em`)
                .text(word);
              lineNumber++;
            }
          }

          textElement.attr("dy", `-${(lineNumber * lineHeight) / 2}em`);
        });
      };

      const label = svg
        .append("g")
        .attr("pointer-events", "none")
        .attr("text-anchor", "middle")
        .style("user-select", "none")
        .selectAll("text")
        .data(root.descendants().slice(1))
        .join("text")
        .attr("fill-opacity", (d) => +labelVisible(d.current))
        .attr("transform", (d) => labelTransform(d.current))
        .text((d) => d.data?.name)
        .each(function() {
          wrapText(d3.select(this), 50);
        });

      const parent = svg
        .append("circle")
        .datum(root)
        .attr("r", radius)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .on("click", clicked);

      // Función para manejar el zoom al hacer clic
      function clicked(event, p) {
        parent.datum(p.parent || root);

        root.each((d) => {
          d.target = {
            x0:
              Math.max(0, Math.min(1, (d.x0 - p.x0) / (p.x1 - p.x0))) *
              2 *
              Math.PI,
            x1:
              Math.max(0, Math.min(1, (d.x1 - p.x0) / (p.x1 - p.x0))) *
              2 *
              Math.PI,
            y0: Math.max(0, d.y0 - p.depth),
            y1: Math.max(0, d.y1 - p.depth),
          };
        });

        const t = svg.transition().duration(750);

        path
          .transition(t)
          .tween("data", (d) => {
            const i = d3.interpolate(d.current, d.target);
            return (t) => (d.current = i(t));
          })
          .filter(function(d) {
            return +this.getAttribute("fill-opacity") || arcVisible(d.target);
          })
          .attr("fill-opacity", (d) =>
            arcVisible(d.target) ? (d.children ? 0.6 : 0.4) : 0
          )
          .attr("pointer-events", (d) =>
            arcVisible(d.target) ? "auto" : "none"
          )
          .attrTween("d", (d) => () => arc(d.current));

        label
          .filter(function(d) {
            return +this.getAttribute("fill-opacity") || labelVisible(d.target);
          })
          .transition(t)
          .attr("fill-opacity", (d) => +labelVisible(d.target))
          .attrTween("transform", (d) => () => labelTransform(d.current));

        // Actualizar el texto central con el nombre del nodo seleccionado
        centralText.text(p.data.name);
      }

      // Funciones auxiliares
      function arcVisible(d) {
        return d.y1 <= 3 && d.y0 >= 1 && d.x1 > d.x0;
      }

      function labelVisible(d) {
        return d.y1 <= 3 && d.y0 >= 1 && (d.y1 - d.y0) * (d.x1 - d.x0) > 0.03;
      }

      function labelTransform(d) {
        const x = (((d.x0 + d.x1) / 2) * 180) / Math.PI;
        const y = ((d.y0 + d.y1) / 2) * radius;
        return `rotate(${x - 90}) translate(${y},0) rotate(${
          x < 180 ? 0 : 180
        })`;
      }
    },
    printORG() {
      const orgElement = document.getElementById("PartitionChart");
      if (!orgElement) {
        console.error("El elemento con id='PartitionChart' no se encontró.");
        return;
      }

      html2canvas(orgElement, {
        scale: 10,
        backgroundColor: null,
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        pdf.addImage(imgData, "PNG", 10, 10, 180, 160);
        pdf.save("org-chart.pdf");
      });
    },
  },
  created() {
    this.load();
  },
};
</script>

<style>
body,
html {
  margin: 0;
  padding: 0;
}

.modal {
  max-width: 100vw;
  max-height: 100vh;
  overflow: auto;
}

.modal-content {
  background-color: #fff;
  width: 297mm;
  /* Ancho de documento A4 */
  height: 210mm;
  /* Alto de documento A4 */
  padding: 0mm 0mm;
  /* Márgenes internos */
  border: 1px solid #000;
}

#table_cabecera {
  position: relative;
  top: 0;
  width: 290mm;
  background-color: #fff;
  border-collapse: collapse;
}
</style>
